import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const ciscoSecureFirewall = defineConnector({
  identifier: "ciscoSecureFirewall",
  name: "Cisco Secure Firewall",
  tagLine: "Firewall management and threat defense",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ host }) => domainToRegex(host),
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: `https://${app.config.host}/api/fmc_platform/v1/auth/generatetoken`,
        basicAuth: {
          username: app.config.username,
          password: app.secret.password,
        },
      },
      extract: { from: "header", name: "x-auth-access-token" },
      apply: { kind: "header", name: "x-auth-access-token" },
    }),
  steps: [
    {
      title: "Prepare your FMC credentials",
      items: [
        {
          kind: "markdown",
          content:
            "You'll need an administrator account on your Firewall Management Center (FMC) with REST API access. Note that API credentials cannot be used simultaneously with the FMC web interface for the same user.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "FMC host",
          required: true,
          placeholder: "fmc.example.com",
          helperText: "Your Firewall Management Center hostname or IP address.",
          target: { kind: "configuration", field: "host" },
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) =>
      `https://${host}/api/fmc_platform/v1/info/serverversion`,
  },
});
